import { createContext, useContext } from 'react';

import { GeneralSettings } from '@/types/setting';

import { Page } from './types';

type PageContextType = Page & {
  generalSettings?: GeneralSettings;
};

const PageContext = createContext<PageContextType | undefined>(undefined);

const usePageContext = (): Partial<PageContextType> => {
  const page = useContext(PageContext);

  return {
    ...page
  };
};

export default PageContext;

export { usePageContext };
